import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { deploymentAlertApi } from '@/api/deploymentAlertApi'
import { WithListParams } from '@/types/pagination'

export const deploymentAlertQueryKeys = {
  all: ['deployment-alert-settings'] as const,
  list: (params?: WithListParams) =>
    [...deploymentAlertQueryKeys.all, 'list', params] as const
}

export const useGetDeploymentAlertSettings = (
  params: WithListParams,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: deploymentAlertQueryKeys.list(params),
    queryFn: () => deploymentAlertApi.getDeploymentAlertSettings(params),
    enabled: options?.enabled
  })
}

export const useCreateDeploymentAlertSetting = () => {
  return useMutation({
    mutationFn: deploymentAlertApi.createDeploymentAlertSetting
  })
}

export const useUpdateDeploymentAlertSetting = () => {
  return useMutation({
    mutationFn: deploymentAlertApi.updateDeploymentAlertSetting
  })
}

export const useDeleteDeploymentAlertSetting = () => {
  return useMutation({
    mutationFn: deploymentAlertApi.deleteDeploymentAlertSetting
  })
}

export const useInvalidateDeploymentAlertSettings = () => {
  const queryClient = useQueryClient()

  const invalidateDeploymentAlertSettings = useCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: [...deploymentAlertQueryKeys.all, 'list']
    })
  }, [queryClient])

  return { invalidateDeploymentAlertSettings }
}
